<template>
  <v-content class="my-12">
    <v-layout class="justify-center">
      <v-flex xs11 mb-4 class="text-center">
        <h1>
          {{
            switchLanguage === "th"
              ? data_page.page_name_th
              : data_page.page_name_en
          }}
        </h1>
      </v-flex>
    </v-layout>

    <v-layout class="justify-center mb-16">
      <v-flex xs10>
        <v-layout>
          <v-flex>
            <div
              class="html-tag"
              v-html="
                switchLanguage === 'th'
                  ? data_page.detail_th
                  : data_page.detail_en
              "
            ></div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Pages",
  computed: {
    ...mapState({
      data_page: (state) => {
        return state.Page.data_page;
      },
      path_url: (state) => {
        return state.Page.path_url;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  created() {
    this.getDataPage(this.$route.query.page);
  },
  methods: {
    ...mapActions("Page", ["getDataPage"]),
  },
};
</script>

<style lang="scss" scoped>
.html-tag {
  /deep/ img {
    max-width: 70%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
